import type { IOption } from 'types/forms'

export const DEFAULT_PAGE_SIZE = 15
export const ITEMS_FOR_PAGES = 5
export const FILTER_VALUES_SEPARATOR = ','
export const DEFAULT_NEWSLETTER_DISTRIBUTION_LIST = 'resource_directory'
export const NEW_USER_TOOLBOX = 'new_user_toolbox'
export const NEW_USER_COACH = 'new_user_coach'
export const MAX_STARS = 5
export const DEFAULT_PEOPLE_TO_SHOW = 4

export const ROUTES = {
  SUBMIT: {
    FORM: '/submit',
    SUCCESS: '/submit/success',
    ERROR: '/submit/error',
    API: '/api/tool/submit.json',
  },
}

export const defaultSeo = {
  title: "AgentHub",
  description: "The Best AI Products on the Internet - Become AI-powered with the top Agents and Tools, specific to your role.",
  ogImage: "https://framerusercontent.com/assets/CKDX31nz5Px3XDUgqb0LGeQavFw.png"
} as any

export enum ACTION {
  UPVOTE = 'tg-upvote',
  DOWNVOTE = 'tg-downvote',
}

export const SortOptions: IOption[] = [
  { label: 'Newest', value: '' },
  { label: 'Oldest', value: 'date_created' },
  { label: 'Name (A-Z)', value: 'title' },
  { label: 'Name (Z-A)', value: '-title' },
]

export const SortOptionsTags: IOption[] = [
  { label: 'Name (A-Z)', value: 'title' },
  { label: 'Name (Z-A)', value: '-title' },
  { label: 'Most popular', value: '-votes' },
]

export const AccessOptions: IOption[] = [
  {
    label: 'Free',
    value: 'free',
    image: '/assets/sparkles.svg',
  },
  {
    label: 'Freemium',
    value: 'freemium',
    image: '/assets/currency-dolar-content.svg',
  },
  {
    label: 'Paid',
    value: 'paid',
    image: '/assets/currency-dolar.svg',
  },
  {
    label: 'Paid (Free Trial)',
    value: 'trial',
    image: '/assets/credit-card.svg',
  },
  {
    label: 'Not launched yet',
    value: 'trial',
    image: '/assets/comingsoon.svg',
  },
]

// This iteration of tags includes categories from below
export const Tags = [
  'Aggregators',
  'AI',
  'Audio Generation',
  'Bug Fix',
  'Business',
  'Chatbot',
  'Code Assistant',
  'Content Generation',
  'Copywriting',
  'Data',
  'Design',
  'Development',
  'E-Commerce',
  'Image Generation',
  'Marketing',
  'Sales',
  'Video Generation',
  'Website Generation',
  'Workflow',
  'Other',
]

// Categories aren't functional yet; we'll leave these here for now
// and copy them to TAGS
export const Categories = [
  'Aggregators',
  'AI',
  'Audio Generation',
  'Bug Fix',
  'Business',
  'Chatbot',
  'Code Assistant',
  'Content Generation',
  'Copywriting',
  'Data',
  'Design',
  'Development',
  'E-Commerce',
  'Image Generation',
  'Marketing',
  'Sales',
  'Video Generation',
  'Website Generation',
  'Workflow',
  'Other',
]

export const PlatformsToShare = {
  twitter: {
    baseURL: 'https://twitter.com/intent/tweet',
    params: {
      text: "🔧 Calling all AWS Developers! 🚀 From coding frameworks to productivity apps, we've got you covered. 💻 Explore now at linkToBeShared, your ultimate directory of tools for AWS developers.",
      via: 'TalentGeniusIO',
      related: 'TalentGeniusIO',
    },
  },
  facebook: {
    baseURL: 'https://www.facebook.com/sharer/sharer.php',
    params: {
      u: 'linkToBeShared',
    },
  },
  linkedin: {
    baseURL: 'https://www.linkedin.com/sharing/share-offsite',
    params: {
      url: 'linkToBeShared',
    },
  },
}

export const SkeletonCard = `<div role="status" class="min-w-10rem p-4 border border-gray-200 rounded shadow animate-pulse md:p-6">
    <div class="flex items-center justify-center h-20 mb-4 bg-gray-300 rounded">
      <svg class="w-12 h-12 text-gray-200" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" fill="currentColor" viewBox="0 0 640 512"><path d="M480 80C480 35.82 515.8 0 560 0C604.2 0 640 35.82 640 80C640 124.2 604.2 160 560 160C515.8 160 480 124.2 480 80zM0 456.1C0 445.6 2.964 435.3 8.551 426.4L225.3 81.01C231.9 70.42 243.5 64 256 64C268.5 64 280.1 70.42 286.8 81.01L412.7 281.7L460.9 202.7C464.1 196.1 472.2 192 480 192C487.8 192 495 196.1 499.1 202.7L631.1 419.1C636.9 428.6 640 439.7 640 450.9C640 484.6 612.6 512 578.9 512H55.91C25.03 512 .0006 486.1 .0006 456.1L0 456.1z"/></svg>
    </div>
    <div class="h-2.5 bg-gray-200 rounded-full w-full mb-4"></div>
    <div class="h-2 bg-gray-200 rounded-full mb-2.5"></div>
    <div class="h-2 bg-gray-200 rounded-full mb-2.5"></div>
    <div class="h-2 bg-gray-200 rounded-full"></div>
    <div class="flex items-center mt-4 space-x-3">
      <div>
        <div class="h-2.5 bg-gray-200 rounded-full w-full mb-2"></div>
        <div class="w-12 h-2 bg-gray-200 rounded-full"></div>
      </div>
    </div>
    <span class="sr-only">Loading...</span>
  </div>`

export const PREDEFINED_LISTS = ['used-by', 'bookmarks', 'follows', 'tag-follows']

export const submitNewsletterErrorMessageClass = 'input-error-message ml-2 mt-1 text-xs text-red-700'
